import imageParser from './image';
import actionParser from '../props/action';
import textStyle from '../props/text-style';
import position, { POSITION } from '../props/position';
import size, { SIZE } from '../props/size';
import align, { ALIGNMENT } from '../props/align';
import text from '../props/text';
import { WEIGHT } from '../../const';

/**
 * Фабрика елемента cell-element
 * @see https://github.yandex-team.ru/portal/morda-schema/blob/master/api/search/2/div/div-table-block.json
 * @param  {Object} element
 * @return {Object}
 */
export default (function (element) {
    if (!element) {
        return null;
    }

    return {
        action: actionParser(element),
        image: imageParser(element.image),
        imageSize: size(element.image_size, SIZE.m),
        imagePosition: position(element.image_position, POSITION.center),
        text: text(element.text),
        textStyle: textStyle(element.text_style),
        horizontalAlignment: align(element.horizontal_alignment),
        verticalAlignment: align(element.vertical_alignment || ALIGNMENT.center),
        weight: WEIGHT.cell
    };
});